
import { AnalyticsEventData } from '@client/analytics/types/types';
import { createAction } from '@reduxjs/toolkit';

export const analyzePageView = createAction<AnalyticsEventData>('analyzePageView');
export const analyzeProductNotFoundPageView = createAction('analyzeProductNotFoundPageView');
